import React, { Component } from 'react'
import { Card, CardHeader, CardBody } from 'reactstrap'
import PropTypes from 'prop-types'
import { Button, NavItem, NavLink, Nav, TabContent, TabPane, ButtonGroup } from 'reactstrap'
import DownloadModal from './DownloadModal'
import ImportWeldsForm from '../Import/ImportWeldsForm'
import { UnmountClosed } from 'react-collapse'
import { connect } from 'react-redux'
import { updateBreadcrumbs } from '../../actions/breadcrumbs'
import { graphql, compose, withApollo } from 'react-apollo'
import { WpsAndInspectionsDictionariesQuery, ElementsListQuery, CreateExportWeldsList, UserProjectConfigurationQuery, CreateOrUpdateUserProjectConfiguration, WeldNumericFilterValuesQuery } from './mutations'
import { GET_JOBS } from '../JobsNotifications/graphql'
import WeldsDataGrid from '../Welds/WeldsDataGrid'
import { FinalReportModal } from '../FinalReport'
import { BlockWithLoader } from '../Support'
import { ElementsTab, ElementTab, NdtTab, GroupingWeldsTab } from './tabs/'
import GridColumnConfiguration from './GridColumnConfiguration'

import { getUserPermissions } from '../../utils/userPermissions'
import WELD_COLUMN_DEFINITIONS from '../Welds/helpers/weldColumnDefinitions'

class Elements extends Component {

  constructor(props) {
    super(props)
    const tabMap = { welds: '1', ndt: '5', elements: '2', details: '3', config: '4', 'grouping-welds': '6' }
    const tabFromUrl = tabMap[props.match.params.tab] || '1'

    const tabPermissions = [
      { tab: '2', perm: 'wl_welds.show_project_elements.show_project_elements' },
      { tab: '1', perm: 'wl_welds.show_project_welds.show_project_welds' },
      { tab: '6', perm: 'wl_welds.show_project_grouping_welds.show_project_grouping_welds' },
      { tab: '5', perm: 'wl_welds.show_project_ndt.show_project_ndt' },
      { tab: '3', perm: 'wl_welds.show_details_project_configuration.show_details_project_configuration' },
      { tab: '4', perm: 'wl_welds.show_user_project_configuration.show_user_project_configuration' }
    ]
    const hasAccess = tabPermissions.find(t => t.tab === tabFromUrl && getUserPermissions(t.perm))
    const firstAvailable = tabPermissions.find(t => getUserPermissions(t.perm))
    const activeTab = hasAccess ? tabFromUrl : (firstAvailable ? firstAvailable.tab : null)

    this.state = {
      element: {},
      wps_list: [],
      welding_consumables: [],
      weldNumericFilterValues: {},
      inspection_category_types: null,
      importFormIsOpened: false,
      finalReportModalOpened: false,
      exportModalOpened: false,
      weldTypeDict: [],
      selected_weld_ids: [],
      activeTab: activeTab,
      userColumnConfig: null,
      configLoading: false,
      groupingState: { selectedTypeId: '', minWelds: 2, groupByKeys: {} }
    }

    this.toggleTab = this.toggleTab.bind(this)
    this.handleImportFormToggle = this.handleImportFormToggle.bind(this)
    this.handleExport = this.handleExport.bind(this)
    this.handleExportModalToggle = this.handleExportModalToggle.bind(this)
    this.handleExportConfirm = this.handleExportConfirm.bind(this)
    this.handleSaveColumnConfig = this.handleSaveColumnConfig.bind(this)
    this.loadUserColumnConfig = this.loadUserColumnConfig.bind(this)
  }

  static propTypes = {
    client: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    updateBreadcrumbs: PropTypes.func.isRequired
  }

  componentWillMount() {
    this.props.client.query({
      query: WpsAndInspectionsDictionariesQuery,
      fetchPolicy: 'network-only',
      variables: { project_id: this.props.match.params.id },
    }).then(({ data }) => {
      let weld_type_dict = []
      data.type_of_welds.forEach(weld_type => {
        weld_type_dict.push({ text: weld_type.name, label: weld_type.name, value: weld_type.id.toString(), id: weld_type.id })
        if (weld_type.name === 'BW' || weld_type.name === 'T-joint') {
          data.joint_types.forEach(joint_type => {
            let weld_type_joint = { val: `${weld_type.id}-${joint_type.id}`, name: `${weld_type.name}-${joint_type.name}` }
            weld_type_dict.push({ text: weld_type_joint.name, label: weld_type_joint.name, value: weld_type_joint.val, id: weld_type_joint.val })
          })
        }
      })

      this.setState({ wps_list: data.wps_list.list, inspection_category_types: data.inspection_category_types, weldTypeDict: weld_type_dict, welding_consumables: data.welding_consumables })
    })

    const projectId = this.props.match.params.id
    const numericColumns = ['length', 'diameter_1', 'thickness_1', 'diameter_2', 'thickness_2']
    this.fetchNumericFilterValues(projectId, false)
  }

  fetchNumericFilterValues(projectId, includeDescendants) {
    const numericColumns = ['length', 'diameter_1', 'thickness_1', 'diameter_2', 'thickness_2']
    Promise.all(numericColumns.map(col =>
      this.props.client.query({
        query: WeldNumericFilterValuesQuery,
        variables: { project_id: projectId, column: col, include_project_descendants_welds: includeDescendants },
        fetchPolicy: 'network-only'
      }).then(({ data }) => [col, data.weld_numeric_filter_values])
        .catch(() => [col, []])
    )).then(results => {
      this.setState({ weldNumericFilterValues: Object.fromEntries(results) })
    })
  }

  componentDidMount() {
    const main = document.querySelector('main.main')
    if (main) main.style.overflowY = 'hidden'
  }

  componentWillUnmount() {
    const main = document.querySelector('main.main')
    if (main) main.style.overflowY = ''
    this.props.updateBreadcrumbs([])
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.tab !== this.props.match.params.tab || nextProps.match.params.id !== this.props.match.params.id) {
      const tabMap = { welds: '1', ndt: '5', elements: '2', details: '3', config: '4', 'grouping-welds': '6' }
      const tabFromUrl = tabMap[nextProps.match.params.tab] || null
      const tabPermissions = [
        { tab: '2', perm: 'wl_welds.show_project_elements.show_project_elements' },
        { tab: '1', perm: 'wl_welds.show_project_welds.show_project_welds' },
        { tab: '6', perm: 'wl_welds.show_project_grouping_welds.show_project_grouping_welds' },
        { tab: '5', perm: 'wl_welds.show_project_ndt.show_project_ndt' },
        { tab: '3', perm: 'wl_welds.show_details_project_configuration.show_details_project_configuration' },
        { tab: '4', perm: 'wl_welds.show_user_project_configuration.show_user_project_configuration' }
      ]
      const hasAccess = tabFromUrl && tabPermissions.find(t => t.tab === tabFromUrl && getUserPermissions(t.perm))
      const firstAvailable = tabPermissions.find(t => getUserPermissions(t.perm))
      const activeTab = hasAccess ? tabFromUrl : (firstAvailable ? firstAvailable.tab : null)
      this.setState({ activeTab })
    }

    if (nextProps.data.loading === false && nextProps.data.element) {
      const isFirstLoad = !this.state.element.id && nextProps.data.element.id
      this.setState({ element: nextProps.data.element }, () => {
        if (isFirstLoad) {
          this.loadUserColumnConfig()
        }
      })

      // BREADCRUMBS
      let breadcrumbs_data = nextProps.data.element.parents.map(o => ({ id: o.id, name: o.name }))
      this.props.updateBreadcrumbs(breadcrumbs_data)
    }
  }

  toggleTab(tabNo) {
    const reverseTabMap = { '1': 'welds', '5': 'ndt', '2': 'elements', '3': 'details', '4': 'config', '6': 'grouping-welds' }
    const tabSlug = reverseTabMap[tabNo] || 'welds'
    this.props.history.replace(`/projects/${tabSlug}/${this.props.match.params.id}${this.props.location.search}`)
    if (tabNo === '4') {
      this.loadUserColumnConfig()
    }
    if (tabNo === '1' && this.state.element.depth === 1) {
      this.loadUserColumnConfig()
    }
    this.setState({ activeTab: tabNo })
    if (tabNo === '3') {
      this.setState(s => ({ editKey: (s.editKey || 0) + 1 }))
    }
  }

  handleImportFormToggle() {
    this.setState({ importFormIsOpened: !this.state.importFormIsOpened })
  }

  handleExport(e) {
    e.stopPropagation()
    const params = new URLSearchParams(this.props.location.search)
    const skip = new Set(['sort_by', 'sort_dir', 'descendants_welds'])
    const filters = {}
    params.forEach((value, key) => {
      if (skip.has(key) || !value) return
      if (filters[key]) {
        filters[key] = [].concat(filters[key], value)
      } else {
        filters[key] = value
      }
    })
    const includeDescendants = params.get('descendants_welds') === 'true'
    this.setState({ exportModalOpened: true, exportFilters: filters, exportIncludeDescendants: includeDescendants })
  }

  handleExportModalToggle() {
    this.setState({ exportModalOpened: !this.state.exportModalOpened })
  }

  handleExportConfirm(params) {
    const { activeTab, weldFormat, ndtInspectionType, scope } = params
    const projectId = Number(this.props.match.params.id)

    const inspectionTypes = this.state.inspection_category_types || []
    const selectedType = inspectionTypes.find(t => String(t.id) === String(ndtInspectionType))
    const isRi = selectedType && selectedType.name === 'RI'

    const format = activeTab === 'welds' ? weldFormat
      : activeTab === 'ndt' ? (isRi ? 'xlsx_order_ri' : 'xlsx_order_ndt')
        : 'xlsx_report'

    const now = new Date()
    const localTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 19).replace('T', ' ')
    const args = { format, version: 'welds', project_id: projectId, current_time: localTime, include_project_descendants_welds: this.state.exportIncludeDescendants || false }

    if (activeTab === 'ndt' && !isRi && ndtInspectionType) {
      args.ndt_inspection_type_id = Number(ndtInspectionType)
    }

    if (scope === 'filtered') {
      args.filters = this.state.exportFilters
    }

    this.props.mutate({ variables: { type: 'WlWelds::Jobs::ExportWeldsList', args: JSON.stringify(args) } })
      .then(() => {
        this.props.client.query({ query: GET_JOBS, fetchPolicy: 'network-only' }).then(({ data }) => {
          const notifyCount = data.user_jobs ? data.user_jobs.filter(job => job.notify).length : 0
          window.dispatchEvent(new CustomEvent('changeNotifyCountInApp', { detail: { notifyCount } }))
        })
        this.setState({ exportModalOpened: false })
      })
      .catch(err => console.error('Export error:', err))
  }

  getAvailableColumns() {
    const extraColumns = []

    if (this.state.element && this.state.element.extra_columns) {
      try {
        const parsed = JSON.parse(this.state.element.extra_columns)
        Object.keys(parsed).forEach(key => extraColumns.push({ id: key, name: parsed[key] }))
      } catch (e) {
        console.error('Error parsing extra_columns:', e)
      }
    }

    const inspectionColumns = []
    if (this.state.element && this.state.element.inspection_categories && this.state.inspection_category_types) {
      const projectInspections = []
      this.state.element.inspection_categories.forEach(inspCat => {
        inspCat.inspections.forEach(insp => {
          if (!projectInspections.includes(insp.type_id)) projectInspections.push(insp.type_id)
        })
      })
      this.state.inspection_category_types.forEach(inspType => {
        if (projectInspections.includes(Number(inspType.id))) {
          inspectionColumns.push({ id: `$inspections_${inspType.id}`, name: inspType.name })
        }
      })
    }

    const statusIndex = WELD_COLUMN_DEFINITIONS.findIndex(c => c.id === 'status')
    return [
      ...WELD_COLUMN_DEFINITIONS.slice(0, statusIndex),
      ...extraColumns,
      ...inspectionColumns,
      ...WELD_COLUMN_DEFINITIONS.slice(statusIndex)
    ]
  }

  loadUserColumnConfig() {
  const projectId = (this.state.element.root_project && this.state.element.root_project.id) || this.props.match.params.id
  this.setState({ configLoading: true })
  this.props.client.query({
    query: UserProjectConfigurationQuery,
    variables: {
      project_id: Number(projectId),
      type: 'user_column_configuration'
    },
    fetchPolicy: 'network-only'
  }).then(({ data }) => {
    let config = null
    if (data.user_project_configuration && data.user_project_configuration.configuration) {
      config = JSON.parse(data.user_project_configuration.configuration)
    }
    this.setState({
      userColumnConfig: config,
      configLoading: false
    })
  }).catch(() => {
    this.setState({ configLoading: false })
  })
  }

  handleSaveColumnConfig(config) {
  const projectId = (this.state.element.root_project && this.state.element.root_project.id) || this.props.match.params.id
  this.props.client.mutate({
    mutation: CreateOrUpdateUserProjectConfiguration,
    variables: {
      attributes: {
        project_id: Number(projectId),
        type: 'user_column_configuration',
        configuration: config
      }
    }
  }).then(({ data }) => {
    if (data.createOrUpdateUserProjectConfiguration.user_project_configuration) {
      this.setState({
        userColumnConfig: data.createOrUpdateUserProjectConfiguration.user_project_configuration.configuration
      })
    }
  }).catch((error) => {
    console.error('Error saving configuration:', error)
    alert('Error saving configuration')
  })
  }

  render() {
  if (this.props.data.error) {
    if (this.props.data.error.networkError && this.props.data.error.networkError.statusCode === 404) {
      return (<div>Not Found</div>)
    } else {
      return (<div>An unexpected error occurred</div>)
    }
  }

  return (
    <BlockWithLoader loading={this.props.data.loading} renderChildren={true}>
      {this.state.finalReportModalOpened &&
        <FinalReportModal
          toggleFunction={() => this.setState({ finalReportModalOpened: false })}
          projectId={Number(this.props.match.params.id)}
          selectedWeldIds={this.state.selected_weld_ids}
        />}
      <UnmountClosed isOpened={this.state.importFormIsOpened}>
        <ImportWeldsForm project_id={Number(this.props.match.params.id)}
          formToggleFunction={this.handleImportFormToggle} />
      </UnmountClosed>
      <DownloadModal
        isOpen={this.state.exportModalOpened}
        toggle={this.handleExportModalToggle}
        onConfirm={this.handleExportConfirm}
        inspectionTypes={(() => {
          const inspCatList = this.state.element.inspection_categories || []
          const dict = this.state.inspection_category_types || []
          const projectTypeIds = [...new Set(inspCatList.flatMap(cat => cat.inspections.map(i => i.type_id)))]
          return dict.filter(t => projectTypeIds.includes(Number(t.id)))
        })()}
      />
      <Card>
        <CardHeader>
          <b>{this.state.element.name}</b>
          {this.state.element.company_permitted && <ButtonGroup className='float-right'>
            {this.state.element.depth === 1 && getUserPermissions('wl_welds.generate_final_report.generate_final_report') &&
              <Button id="final-report-btn" color="primary" title="Final report"
                onClick={(e) => {
                  e.stopPropagation()
                  this.setState({ finalReportModalOpened: true })
                }}
              >
                <b>Final report <i className='fa fa-book' /></b>
              </Button>}
            {this.state.element.depth === 1 && getUserPermissions('wl_welds.show_inspection_category_configuration.show_inspection_category_configuration') &&
              <Button id="add-insp-cat-btn" color="success" title="Inspection Category"
                onClick={(e) => {
                  e.stopPropagation()
                  this.props.history.push(`/projects/${this.props.match.params.id}/inspection-category`)
                }}>
                <i className="fa fa-pencil " />
              </Button>}
            {this.state.element.id && this.state.element.inspection_categories.length > 0 && !this.state.importFormIsOpened && getUserPermissions('wl_welds.import_welds.import_welds') && (window.location.href.includes('gpbaltic') || window.location.href.includes('demo') || window.location.href.includes('localhost') || window.location.href.includes('crist')) &&
              <Button id="import-btn" color="secondary" title="Import"
                onClick={() => { this.setState({ importFormIsOpened: true }) }}>
                <i className="fa fa-arrow-up" />
              </Button>}
            {this.state.element.id && this.state.element.inspection_categories.length > 0 && !this.state.importFormIsOpened && getUserPermissions('wl_welds.export_welds.export_welds') &&
              <Button id="export-btn" color="primary" title="Export"
                onClick={this.handleExport}>
                <i className="fa fa-arrow-down" />
              </Button>}
          </ButtonGroup>}
        </CardHeader>
        <CardBody style={{padding: 0, overflow: 'hidden', height: 'calc(100vh - 143px)'}}>
          {this.state.activeTab === null ? (
            <p style={{ padding: '20px', color: '#999' }}>You do not have permissions to view this project.</p>
          ) : (<React.Fragment>
          <Nav tabs>
            {getUserPermissions('wl_welds.show_project_elements.show_project_elements') && <NavItem>
              <NavLink
                active={this.state.activeTab === '2'}
                onClick={() => { this.toggleTab('2') }}
                style={{ cursor: 'pointer' }}
              >
                <b>Elements</b>
              </NavLink>
            </NavItem>}
            {getUserPermissions('wl_welds.show_project_welds.show_project_welds') && <NavItem>
              <NavLink
                active={this.state.activeTab === '1'}
                onClick={() => { this.toggleTab('1') }}
                style={{ cursor: 'pointer' }}
              >
                <b>Welds</b>
              </NavLink>
            </NavItem>}
            {getUserPermissions('wl_welds.show_project_grouping_welds.show_project_grouping_welds') && <NavItem>
              <NavLink
                active={this.state.activeTab === '6'}
                onClick={() => { this.toggleTab('6') }}
                style={{ cursor: 'pointer' }}
              >
                <b>Grouping welds</b>
              </NavLink>
            </NavItem>}
            {getUserPermissions('wl_welds.show_project_ndt.show_project_ndt') && <NavItem>
              <NavLink
                active={this.state.activeTab === '5'}
                onClick={() => { this.toggleTab('5') }}
                style={{ cursor: 'pointer' }}
              >
                <b>NDT</b>
              </NavLink>
            </NavItem>}
            {this.state.element.company_permitted && getUserPermissions('wl_welds.show_details_project_configuration.show_details_project_configuration') && <NavItem>
              <NavLink
                active={this.state.activeTab === '3'}
                onClick={() => { this.toggleTab('3') }}
                style={{ cursor: 'pointer' }}
              >
                <b>{this.state.element.name} - Details</b>
              </NavLink>
            </NavItem>}
            {this.state.element.company_permitted && this.state.element.depth === 1 && getUserPermissions('wl_welds.show_user_project_configuration.show_user_project_configuration') && <NavItem style={{ marginLeft: 'auto' }}>
              <NavLink
                active={this.state.activeTab === '4'}
                onClick={() => { this.toggleTab('4') }}
                style={{ cursor: 'pointer' }}
              >
                <b>User project configuration</b>
              </NavLink>
            </NavItem>}
          </Nav>
          <TabContent activeTab={this.state.activeTab[0]}>
            <TabPane tabId="1">
              {this.state.activeTab === '1' &&
                this.props.data.loading === false && this.state.inspection_category_types &&
                Object.keys(this.state.weldNumericFilterValues).length > 0 &&
                <WeldsDataGrid
                  parentElement={this.state.element}
                  projectId={Number(this.props.match.params.id)}
                  extraColumns={this.state.element.extra_columns ? JSON.parse(this.state.element.extra_columns) : {}}
                  inspCatList={this.state.element.inspection_categories}
                  inspCatTypesDict={this.state.inspection_category_types}
                  wpsList={this.state.wps_list}
                  weldingConsumables={this.state.welding_consumables}
                  history={this.props.history}
                  weldTypeDict={this.state.weldTypeDict}
                  weldNumericFilterValues={this.state.weldNumericFilterValues}
                  getSelectedWeldIds={this.state.finalReportModalOpened && ((ids) => this.setState({ selected_weld_ids: ids }))}
                  userColumnConfig={this.state.userColumnConfig}
                  onDescendantsChange={(includeDescendants) => this.fetchNumericFilterValues(this.props.match.params.id, includeDescendants)}
                />}
            </TabPane>
            <TabPane tabId="6">
              {this.state.activeTab === '6' &&
                <GroupingWeldsTab
                  parentId={Number(this.props.match.params.id)}
                  inspCatTypesDict={this.state.inspection_category_types || []}
                  inspCatList={this.state.element.inspection_categories || []}
                  groupingState={this.state.groupingState}
                  onGroupingStateChange={groupingState => this.setState({ groupingState })}
                />}
            </TabPane>
            <TabPane tabId="5">
              {this.state.activeTab === '5' &&
                <NdtTab parentId={Number(this.props.match.params.id)} history={this.props.history} location={this.props.location} />}
            </TabPane>
            <TabPane tabId="2">
              {this.state.activeTab === '2' &&
                <ElementsTab
                  history={this.props.history}
                  location={this.props.location}
                  parentElement={this.state.element}
                  parentId={Number(this.props.match.params.id)}
                  companiesData={this.props.data.companies ? this.props.data.companies.list : []}
                />}
            </TabPane>
            {this.state.element.company_permitted && this.state.element.depth === 1 && <TabPane tabId="4">
              {this.state.activeTab === '4' && (
                this.state.configLoading ? (
                  <div style={{ textAlign: 'center', padding: '50px' }}>
                    <i className="fa fa-spinner fa-spin" style={{ fontSize: '48px', color: '#20a8d8' }} />
                  </div>
                ) : (

                  <GridColumnConfiguration
                    availableColumns={this.getAvailableColumns()}
                    projectId={Number(this.props.match.params.id)}
                    onSave={this.handleSaveColumnConfig}
                    userConfig={this.state.userColumnConfig}
                  />
                )
              )}
            </TabPane>}
            {this.state.element.company_permitted && <TabPane tabId="3">
              {this.state.activeTab === '3' &&
                <ElementTab
                  key={this.state.editKey || 0}
                  parentId={Number(this.props.match.params.id)}
                  companiesData={this.props.data.companies ? this.props.data.companies.list : []} />}
              <br /><br />
            </TabPane>}
          </TabContent>
          </React.Fragment>)}
        </CardBody>
      </Card>
    </BlockWithLoader>
  )
}
}

const ElementsWithMutations = compose(
  graphql(ElementsListQuery, {
    options: (props) => ({
      fetchPolicy: 'network-only',
      variables: {
        parent_id: Number(props.match.params.id)
      }
    })
  }),
  graphql(CreateExportWeldsList, { name: 'mutate' })
)(Elements)

export default connect(null, { updateBreadcrumbs })(withApollo(ElementsWithMutations))



// WEBPACK FOOTER //
// ./src/components/Projects/Elements.js